import React from 'react'
import { connect } from 'react-redux'
import { Box, Text } from 'grommet'
import NumberFormat from 'react-number-format'
import { startCase, get, isEqual } from 'lodash/fp'

import FormField from './FormField'
import FieldSet from './FieldSet'

const OrderReview = ({
  product,
  productSku,
  art,
  list,
  quantity,
  mailType,
  amount,
  skuName,
  productName,
}) => (
  <Box flex="grow" responsive>
    <FieldSet horizontal border={{ size: 'none' }}>
      <Text size="small" color="dark-2">
        Product
      </Text>
      <FormField
        label={`${isEqual(product, 'postcards') ? productName : ''} ${skuName}`}
      />
    </FieldSet>
    <FieldSet horizontal border={{ size: 'none' }}>
      <Text size="small" color="dark-2">
        Design
      </Text>
      <FormField label={art} />
    </FieldSet>
    <FieldSet horizontal border={{ size: 'none' }}>
      <Text size="small" color="dark-2">
        List
      </Text>
      <FormField label={list} />
    </FieldSet>
    <FieldSet horizontal border={{ size: 'none' }}>
      <Text size="small" color="dark-2">
        Quantity
      </Text>
      <FormField
        label={
          <NumberFormat
            value={quantity}
            displayType={'text'}
            thousandSeparator={true}
          />
        }
      />
    </FieldSet>
    <FieldSet horizontal border={{ size: 'none' }}>
      <Text size="small" color="dark-2">
        How do you want to mail them?
      </Text>
      <FormField label={mailType} />
    </FieldSet>
    <FieldSet horizontal border={{ side: 'top', size: 'xsmall' }}>
      <Text size="small">Total</Text>
      <FormField
        label={
          <NumberFormat
            value={amount / 100}
            displayType={'text'}
            thousandSeparator={true}
            prefix={'$'}
            fixedDecimalScale={true}
            decimalScale={2}
          />
        }
      />
    </FieldSet>
  </Box>
)

const mapStateToProps = (state, ownProps) => {
  const productSku = state.order.productSku
  const skuInfo = state.order.productInfo
  const quantity = state.order.quantity
  const skuName = get('attributes.name', skuInfo)
  const productName = get('product.name', skuInfo)
  const amount = get('price', skuInfo) * quantity

  return {
    productSku,
    art: state.order.art.none ? 'Need Art' : 'Uploaded Design',
    list: state.order.noList ? 'Need List' : 'Uploaded List',
    mailType: startCase(state.order.mailType),
    quantity,
    amount,
    skuName,
    productName,
  }
}

export default connect(mapStateToProps)(OrderReview)
